export const AGENT_UPDATED = "agent_updated";
export const SESSION_UPDATED = "session_updated";
export const MESSAGE_COUNT_UPDATED = "message_count_updated";
export const MESSAGE_LIST_UPDATED = "message_list_updated";
export const CHAT_STATE_CHANGED = "chat_state_changed";